<template>
  <section id="picked">
      <transition-group name="slide">
          <p v-for="(person, index) in pickedNames" :key="`${person.id}${index}`">{{person.name}}</p>
      </transition-group>
  </section>
</template>

<script>
export default {
    name: 'PickedNames',
    computed: {
        pickedNames(){
            return this.$store.state.pickedNames;
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';

#picked {
    max-width: 14rem;
    width: 100%;
    height: 100vh;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 1rem;
    opacity: .8;
    overflow: hidden;
    mask-image: -webkit-gradient(linear, left 0%, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));

    p {
        font-size: $font-sml;
        font-weight: 200;
        margin: .125rem 0;
        text-align: right;
    }
}

.slide-enter-active, .slide-leave-active {
  transition: all .5s;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(20px);
}
</style>